export default __webpack_public_path__ + "static/media/3EPS.d897f315.png";